import React from 'react';
import { Button, Modal } from 'rsuite';

interface Props {
  children: JSX.Element;
  title: string;
  isOpen: boolean;
  isLoading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  onClose?: () => void;
}

export default function Alert({
  children, title, isOpen, isLoading, confirmLabel, cancelLabel, onConfirm, onCancel, onClose,
}: Readonly<Props>) {
  function handleCancel() {
    if (onCancel) {
      onCancel();
      return;
    }

    onClose?.();
  }

  return (
    <Modal
      backdrop="static"
      role="alertdialog"
      open={isOpen}
      onClose={() => onClose?.()}
      size="xs"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onConfirm()}
          appearance="primary"
          loading={isLoading}
        >
          {confirmLabel}
        </Button>
        <Button
          onClick={() => handleCancel()}
          appearance="subtle"
          disabled={isLoading}
        >
          {cancelLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

Alert.defaultProps = {
  isLoading: false,
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  onCancel: undefined,
  onClose: undefined,
};
